// import p1_img from "./product_1.png";
// import p2_img from "./product_2.png";
// import p3_img from "./product_3.png";
// import p4_img from "./product_4.png";
// import p5_img from "./product_5.png";
// import p6_img from "./product_6.png";
// import p7_img from "./product_7.png";
// import p8_img from "./product_8.png";
// import p9_img from "./product_9.png";
// import p10_img from "./product_10.png";
// import p11_img from "./product_11.png";
// import p12_img from "./product_12.png";
// import p13_img from "./product_13.png";
// import p14_img from "./product_14.png";
// import p15_img from "./product_15.png";
// import p16_img from "./product_16.png";
// import p17_img from "./product_17.png";
// import p18_img from "./product_18.png";
// import p19_img from "./product_19.png";
// import p20_img from "./product_20.png";
// import p21_img from "./product_21.png";
// import p22_img from "./product_22.png";
// import p23_img from "./product_23.png";
// import p24_img from "./product_24.png";
// import p25_img from "./product_25.png";
// import p26_img from "./product_26.png";
// import p27_img from "./product_27.png";
// import p28_img from "./product_28.png";
// import p29_img from "./product_29.png";
// import p30_img from "./product_30.png";
// import p31_img from "./product_31.png";
// import p32_img from "./product_32.png";
// import p33_img from "./product_33.png";
// import p34_img from "./product_34.png";
// import p35_img from "./product_35.png";
// import p36_img from "./product_36.png";

// let all_product = [
//   {
//     id: 1,
//     name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
//     category: "women",
//     image: p1_img,
//     new_price: 50.0,
//     old_price: 80.5,
//   },
//   {
//     id: 2,
//     name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
//     category: "women",
//     image: p2_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 3,
//     name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
//     category: "women",
//     image: p3_img,
//     new_price: 60.0,
//     old_price: 100.5,
//   },
//   {
//     id: 4,
//     name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
//     category: "women",
//     image: p4_img,
//     new_price: 100.0,
//     old_price: 150.0,
//   },
//   {
//     id: 5,
//     name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
//     category: "women",
//     image: p5_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 6,
//     name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
//     category: "women",
//     image: p6_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 7,
//     name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
//     category: "women",
//     image: p7_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 8,
//     name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
//     category: "women",
//     image: p8_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 9,
//     name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
//     category: "women",
//     image: p9_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 10,
//     name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
//     category: "women",
//     image: p10_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 11,
//     name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
//     category: "women",
//     image: p11_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 12,
//     name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
//     category: "women",
//     image: p12_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 13,
//     name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
//     category: "men",
//     image: p13_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 14,
//     name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
//     category: "men",
//     image: p14_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 15,
//     name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
//     category: "men",
//     image: p15_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 16,
//     name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
//     category: "men",
//     image: p16_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 17,
//     name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
//     category: "men",
//     image: p17_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 18,
//     name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
//     category: "men",
//     image: p18_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 19,
//     name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
//     category: "men",
//     image: p19_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 20,
//     name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
//     category: "men",
//     image: p20_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 21,
//     name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
//     category: "men",
//     image: p21_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 22,
//     name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
//     category: "men",
//     image: p22_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 23,
//     name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
//     category: "men",
//     image: p23_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 24,
//     name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
//     category: "men",
//     image: p24_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 25,
//     name: "Boys Orange Colourblocked Hooded Sweatshirt",
//     category: "kid",
//     image: p25_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 26,
//     name: "Boys Orange Colourblocked Hooded Sweatshirt",
//     category: "kid",
//     image: p26_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 27,
//     name: "Boys Orange Colourblocked Hooded Sweatshirt",
//     category: "kid",
//     image: p27_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 28,
//     name: "Boys Orange Colourblocked Hooded Sweatshirt",
//     category: "kid",
//     image: p28_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 29,
//     name: "Boys Orange Colourblocked Hooded Sweatshirt",
//     category: "kid",
//     image: p29_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 30,
//     name: "Boys Orange Colourblocked Hooded Sweatshirt",
//     category: "kid",
//     image: p30_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 31,
//     name: "Boys Orange Colourblocked Hooded Sweatshirt",
//     category: "kid",
//     image: p31_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 32,
//     name: "Boys Orange Colourblocked Hooded Sweatshirt",
//     category: "kid",
//     image: p32_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 33,
//     name: "Boys Orange Colourblocked Hooded Sweatshirt",
//     category: "kid",
//     image: p33_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 34,
//     name: "Boys Orange Colourblocked Hooded Sweatshirt",
//     category: "kid",
//     image: p34_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 35,
//     name: "Boys Orange Colourblocked Hooded Sweatshirt",
//     category: "kid",
//     image: p35_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
//   {
//     id: 36,
//     name: "Boys Orange Colourblocked Hooded Sweatshirt",
//     category: "kid",
//     image: p36_img,
//     new_price: 85.0,
//     old_price: 120.5,
//   },
// ];

// export default all_product;

import p1_img from "./product_1.png";
import p2_img from "./product_2.png";
import p3_img from "./product_3.png";
import p4_img from "./product_4.png";
import p5_img from "./product_5.png";
import p6_img from "./product_6.png";
import p7_img from "./product_7.png";
import p8_img from "./product_8.png";
import p9_img from "./product_9.png";
import p10_img from "./product_10.png";
import p11_img from "./product_11.png";
import p12_img from "./product_12.png";
import p13_img from "./product_13.png";
import p14_img from "./product_14.png";
import p15_img from "./product_15.png";
import p16_img from "./product_16.png";
import p17_img from "./product_17.png";
import p18_img from "./product_18.png";
import p19_img from "./product_19.png";
import p20_img from "./product_20.png";
import p21_img from "./product_21.png";
import p22_img from "./product_22.png";
import p23_img from "./product_23.png";
import p24_img from "./product_24.png";
import p25_img from "./product_25.png";
import p26_img from "./product_26.png";
import p27_img from "./product_27.png";
import p28_img from "./product_28.png";
import p29_img from "./product_29.png";
import p30_img from "./product_30.png";
import p31_img from "./product_31.png";
import p32_img from "./product_32.png";
import p33_img from "./product_33.png";
import p34_img from "./product_34.png";
import p35_img from "./product_35.png";
import p36_img from "./product_36.png";

let all_product = [
  // 👩 WOMEN
  {
    id: 1,
    name: "Floral Summer Blouse",
    category: "women",
    image: p1_img,
    new_price: 50,
    old_price: 80,
    description: "Lightweight floral blouse with a soft fabric, perfect for summer outings."
  },
  {
    id: 2,
    name: "Elegant White Peplum Top",
    category: "women",
    image: p2_img,
    new_price: 85,
    old_price: 120,
    description: "Elegant peplum top with a modern collar design suitable for casual and formal wear."
  },
  {
    id: 3,
    name: "Striped Office Blouse",
    category: "women",
    image: p3_img,
    new_price: 60,
    old_price: 100,
    description: "Classic striped blouse designed for office and smart casual looks."
  },
  {
    id: 4,
    name: "Casual Daily Wear Top",
    category: "women",
    image: p4_img,
    new_price: 100,
    old_price: 150,
    description: "Comfortable daily wear top made with breathable premium fabric."
  },
  {
    id: 5,
    name: "Chic Collar Blouse",
    category: "women",
    image: p5_img,
    new_price: 85,
    old_price: 120,
    description: "Chic collar blouse with a flattering fit for everyday elegance."
  },
  {
    id: 6,
    name: "Modern Sleeve Blouse",
    category: "women",
    image: p6_img,
    new_price: 85,
    old_price: 120,
    description: "Modern sleeve design with soft texture and stylish finish."
  },
  {
    id: 7,
    name: "Relaxed Fit Women Top",
    category: "women",
    image: p7_img,
    new_price: 85,
    old_price: 120,
    description: "Relaxed fit top offering comfort without sacrificing style."
  },
  {
    id: 8,
    name: "Classic Pattern Blouse",
    category: "women",
    image: p8_img,
    new_price: 85,
    old_price: 120,
    description: "Classic patterned blouse ideal for daily wear and outings."
  },
  {
    id: 9,
    name: "Soft Fabric Casual Blouse",
    category: "women",
    image: p9_img,
    new_price: 85,
    old_price: 120,
    description: "Soft-touch casual blouse designed for all-day comfort."
  },
  {
    id: 10,
    name: "Trendy Overlap Collar Top",
    category: "women",
    image: p10_img,
    new_price: 85,
    old_price: 120,
    description: "Trendy overlap collar top with a modern silhouette."
  },
  {
    id: 11,
    name: "Everyday Women Blouse",
    category: "women",
    image: p11_img,
    new_price: 85,
    old_price: 120,
    description: "Everyday blouse suitable for work or casual wear."
  },
  {
    id: 12,
    name: "Minimal Design Women Top",
    category: "women",
    image: p12_img,
    new_price: 85,
    old_price: 120,
    description: "Minimal design top that pairs well with jeans or skirts."
  },

  // 👨 MEN
  {
    id: 13,
    name: "Men Green Bomber Jacket",
    category: "men",
    image: p13_img,
    new_price: 85,
    old_price: 120,
    description: "Stylish green bomber jacket with a slim fit and zip closure."
  },
  {
    id: 14,
    name: "Casual Zipper Jacket",
    category: "men",
    image: p14_img,
    new_price: 85,
    old_price: 120,
    description: "Casual jacket perfect for everyday wear and light weather."
  },
  {
    id: 15,
    name: "Slim Fit Bomber Jacket",
    category: "men",
    image: p15_img,
    new_price: 85,
    old_price: 120,
    description: "Slim fit bomber jacket offering comfort and a modern look."
  },
  {
    id: 16,
    name: "Classic Men Jacket",
    category: "men",
    image: p16_img,
    new_price: 85,
    old_price: 120,
    description: "Classic jacket design suitable for casual and outdoor use."
  },
  {
    id: 17,
    name: "Urban Style Bomber",
    category: "men",
    image: p17_img,
    new_price: 85,
    old_price: 120,
    description: "Urban style bomber jacket for a trendy appearance."
  },
  {
    id: 18,
    name: "Winter Casual Jacket",
    category: "men",
    image: p18_img,
    new_price: 85,
    old_price: 120,
    description: "Warm and comfortable jacket ideal for cool weather."
  },
  {
    id: 19,
    name: "Everyday Men Bomber",
    category: "men",
    image: p19_img,
    new_price: 85,
    old_price: 120,
    description: "Everyday bomber jacket with durable material."
  },
  {
    id: 20,
    name: "Modern Zip Jacket",
    category: "men",
    image: p20_img,
    new_price: 85,
    old_price: 120,
    description: "Modern zip jacket designed for daily casual outfits."
  },
  {
    id: 21,
    name: "Stylish Outdoor Jacket",
    category: "men",
    image: p21_img,
    new_price: 85,
    old_price: 120,
    description: "Stylish outdoor jacket with a comfortable fit."
  },
  {
    id: 22,
    name: "Lightweight Bomber Jacket",
    category: "men",
    image: p22_img,
    new_price: 85,
    old_price: 120,
    description: "Lightweight bomber jacket perfect for layering."
  },
  {
    id: 23,
    name: "Streetwear Men Jacket",
    category: "men",
    image: p23_img,
    new_price: 85,
    old_price: 120,
    description: "Streetwear-inspired jacket with a modern edge."
  },
  {
    id: 24,
    name: "Comfort Fit Men Jacket",
    category: "men",
    image: p24_img,
    new_price: 85,
    old_price: 120,
    description: "Comfort fit jacket suitable for long wear."
  },

  // 🧒 KIDS
  {
    id: 25,
    name: "Kids Orange Hooded Sweatshirt",
    category: "kid",
    image: p25_img,
    new_price: 85,
    old_price: 120,
    description: "Bright orange hoodie designed for kids comfort and warmth."
  },
  {
    id: 26,
    name: "Color Block Kids Hoodie",
    category: "kid",
    image: p26_img,
    new_price: 85,
    old_price: 120,
    description: "Color block hoodie with soft fabric for daily play."
  },
  {
    id: 27,
    name: "Warm Kids Sweatshirt",
    category: "kid",
    image: p27_img,
    new_price: 85,
    old_price: 120,
    description: "Warm and cozy sweatshirt perfect for winter days."
  },
  {
    id: 28,
    name: "Casual Kids Hoodie",
    category: "kid",
    image: p28_img,
    new_price: 85,
    old_price: 120,
    description: "Casual hoodie offering comfort and freedom of movement."
  },
  {
    id: 29,
    name: "Everyday Kids Sweatshirt",
    category: "kid",
    image: p29_img,
    new_price: 85,
    old_price: 120,
    description: "Everyday sweatshirt suitable for school and playtime."
  },
  {
    id: 30,
    name: "Soft Fabric Kids Hoodie",
    category: "kid",
    image: p30_img,
    new_price: 85,
    old_price: 120,
    description: "Soft fabric hoodie designed for kids sensitive skin."
  },
  {
    id: 31,
    name: "Winter Kids Sweatshirt",
    category: "kid",
    image: p31_img,
    new_price: 85,
    old_price: 120,
    description: "Winter sweatshirt providing warmth and comfort."
  },
  {
    id: 32,
    name: "Playtime Kids Hoodie",
    category: "kid",
    image: p32_img,
    new_price: 85,
    old_price: 120,
    description: "Perfect hoodie for active play and outdoor fun."
  },
  {
    id: 33,
    name: "Classic Kids Sweatshirt",
    category: "kid",
    image: p33_img,
    new_price: 85,
    old_price: 120,
    description: "Classic kids sweatshirt with durable stitching."
  },
  {
    id: 34,
    name: "Daily Wear Kids Hoodie",
    category: "kid",
    image: p34_img,
    new_price: 85,
    old_price: 120,
    description: "Daily wear hoodie suitable for all activities."
  },
  {
    id: 35,
    name: "Comfort Kids Sweatshirt",
    category: "kid",
    image: p35_img,
    new_price: 85,
    old_price: 120,
    description: "Comfort-focused sweatshirt for long wear."
  },
  {
    id: 36,
    name: "Premium Kids Hoodie",
    category: "kid",
    image: p36_img,
    new_price: 85,
    old_price: 120,
    description: "Premium quality hoodie combining style and comfort."
  }
];

export default all_product;
